// TODO: what's happening here?!
export class CommonConfigurations {
}
export class SharedConfigurations extends CommonConfigurations {
}
export class SettingsConfigurations extends SharedConfigurations {
}
export class TrackerSharedConfigurations extends SharedConfigurations {
}
export class PulseMiniConfigurations extends TrackerSharedConfigurations {
}
export class TrackerConfigurations extends TrackerSharedConfigurations {
}
//# sourceMappingURL=configurations.js.map